/** A referential singleton: no tenant, no parameter. */
class FetchRecordingPolicy {
	constructor() {
		Object.freeze(this);
	}
}

export default FetchRecordingPolicy;
